import React from "react";
import MobileCard1 from "./MobileCard1";
import MobileCard2 from "./MobileCard2";
import MobileCard3 from "./MobileCard3";
import MobileCard4 from "./MobileCard4";


export default function MobileUIWF1({cardType}) {
  return (<><div className="phone-wrapperMob">

      {/* LEFT SIDE BUTTONS */}
      <div className="volMobumeMob-buttons">
        <div className="volMob-btn up"></div>
        <div className="volMob-btn down"></div>
      </div>

      {/* RIGHT SIDE POWER BUTTON */}
      <div className="powerMob-btn"></div>

      {/* TOP CAMERA */}
      <div className="cameraMob-area">
        <div className="cameraMob-dot"></div>
        <div className="sensorMob-dot"></div>
      </div><div className="mobile-frame">
      <div className="mobile-screen">
        {cardType==1?<MobileCard4
          image="https://images.unsplash.com/photo-1513258496099-48168024aec0"
          title="Machine Learning Basics"
          lesson="Supervised vs Unsupervised"
          chapters={[
            { title: "What is Supervision?", meta: "06:12 • Video" },
            { title: "Model Overfitting", meta: "08:47 • Video" },
            { title: "Bias/Variance Tradeoff", meta: "09:31 • Quiz", locked: true },
             { title: "What is Supervision?", meta: "06:12 • Video" },
            { title: "Model Overfitting", meta: "08:47 • Video" },
            { title: "Bias/Variance Tradeoff", meta: "09:31 • Quiz", locked: true }
        
          ]}
        />:cardType==2?<MobileCard2 />:""}
         
        
        <div style={{ height: "70px" }}></div>
      </div>
       {/* Bottom Navbar */}
      <div className="bottom-navMob">
        <div className="nav-itemMob activeMob">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 3l9 8h-3v9h-12v-9h-3z"/>
          </svg>
          <span>Home</span>
        </div>

        <div className="nav-itemMob">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path fill="currentColor" d="M4 6h16v2h-16zM4 11h16v2h-16zM4 16h16v2h-16z"/>
          </svg>
          <span>Courses</span>
        </div>

        <div className="nav-itemMob">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/>
          </svg>
          <span>Profile</span>
        </div>
      </div>
    </div>
    </div>
    <style>{`
    .phone-wrapperMob {
  position: relative;transform:scale(0.8);left:-30px;
  width: 316px;
  ;
}
  /* Top cameraMob + sensorMob */
.cameraMob-area {
  position: absolute;
  top: 23px;z-index:11;
  left: 58%;
  transform: translateX(-50%);
  width: 80px;
  height: 24px;
  background: #2a2c35ff;
  border-radius: 0 0 18px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  
}

.cameraMob-dot {
  width: 12px;
  height: 12px;
  background: #18191dff;
  border-radius: 50%;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
}

.sensorMob-dot {
  width: 6px;
  height: 6px;
  background: #2a2e33;
  border-radius: 50%;
}

/* LEFT VOLUME BUTTONS */
.volMobumeMob-buttons {
  position: absolute;
  left: -5px;
  top: 150px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.volMob-btn {
  width: 6px;
  height: 50px;
  background: #333;
  border-radius: 4px;
  box-shadow: inset -2px 0 3px rgba(0,0,0,0.5);
}

.volMob-btn.down {
  height: 40px;
}

/* RIGHT POWER BUTTON */
.powerMob-btn {
  position: absolute;
  right: 5px;
  top: 260px;
  width: 6px;
  height: 70px;
  background: #333;
  border-radius: 4px;
  box-shadow: inset 2px 0 3px rgba(0,0,0,0.5);
}

  /* Phone Frame */
.mobile-frame {
  width: 317px;overflow:hidden;
  height: 720px;
  background: #000;
  border-radius: 38px;
  padding: 18px;
  margin: 20px auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  border: 4px solid #111;
  position: relative;
}

/* Speaker notch */
.mobile-frame::before {
  content: "";
  width: 90px;
  height: 10px;
  background: #222;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}

/* Inside mobile screen */
.mobile-screen {
  width: 100%;
  height: 100%;
  background: #0b0c10;
  border-radius: 30px;
  overflow-y: auto;
  padding-top: 30px;
}
  /* Bottom Navbar */
.bottom-navMob {position:absolute;bottom:0px;left:0px;right:0px;
  height: 65px;
  background: #101218;
  border-radius: 28px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px solid #1a1f2b;
  margin-top: 10px;
}

.nav-itemMob {
  color: #a6b0c2;
  font-size: 11px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2px;
}

.nav-itemMob svg {
  fill: currentColor;
}

.nav-itemMob.activeMob {
  color: #6aa2ff;
}
`}</style>
    
  </>);
}
